<div class="admin-container">
  <h2>Publish changes</h2>
  <button pButton label="Publish" severity="success" (click)="publish()"></button>

  @if(publishing) {
  <p>publishing...</p>
  } @if(published && error) {
  <p class="error">Error: {{ error }}</p>
  } @else if(published) {
  <p class="success">Published successfully</p>
  }
</div>
